export const DOWNLOAD_PATHS = ['/download'] as const
